// loader.component.ts
import { Component, Input } from '@angular/core';
import { NgClass,} from '@angular/common';
@Component({
  selector: 'app-loader',
  templateUrl: './loader-component.html',
  styleUrls: ['./loader-component.scss'],
  imports: [NgClass],
})
export class LoaderComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'small';
  @Input() loaderId!: string;

  get spinnerClass() {
    return `loader-${this.size}`;
  }
}
